<template>
	<div class="passport-field">
		<div class="w5-form-row">
			<div v-for="(field, idx) in fields" class="w5-field" :class="idx" :key="idx" v-if="fieldVisibility(idx)">
				<div class="w5-field-placeholder" :class="{ 'active': field.focused || field.value, 'readonly': readonly }">
					<span class="short-title">{{ field.title | ftc }}<span v-if="required" class="required-field"> *</span></span>
					<span class="long-title">{{ title + ': ' + localeFtc(field.Title).toLowerCase() | ftc }}<span v-if="required" class="required-field"> *</span></span>
				</div>
				<input
					type="text"
					:ref="idx"
					:class="{ 'padded-for-btn': needCopyButton(idx), 'haserror': errorMessage }"
					:disabled="readonly === true ? 'disabled' : false"
					v-model="field.value"
					@focus="onFocus(idx)"
					@blur="onBlur(idx)"
					@keydown.enter="enterKeyDown"
					@input="onInput(idx, $event)" />
				<div v-if="needCopyButton(idx) && !readonly"
					class="field-button-wrapper field-button-password-wrapper"
					:title="'main/copy' | ftc"
					@click="copyAddress">
					<font-awesome-icon icon="copy" />
				</div>
				<transition name="fade" mode="out-in">
					<div class="w5-tooltip-wrapper" v-show="field.focused && !field.error">
						<span class="w5-tooltip">{{ field.hint | ftc }}</span>
					</div>
				</transition>
			</div>
		</div>
		<div v-show="errorMessage"
			class="alert alert-danger w5-alert-valid"
			role="alert"
			v-withSafeTags="localeFtc(errorMessage)" />
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'addressComponent',

	//=========================================================================
	props: [
		'title',
		'required',
		'readonly',
		'name',
		'crud',
		'value',
		'validator',
		'errorMessage',
		'disabled'
	],

	//=========================================================================
	data() {
		return {
			fields: {
				index: {
					focused: false,
					title: this.localeFtc('mail/postcode'),
					Title: this.localeFtc('mail/postcode'),
					hint: 'person/pattern: 101000',
					value: ''
				},
				address: {
					focused: false,
					title: this.localeFtc('mail/address'),
					Title: this.localeFtc('mail/address'),
					hint: 'person/pattern: Москва, ул. Воробьянинова, д. 15, кв. 22',
					value: ''
				},
				receiver: {
					focused: false,
					title: 'main/whom',
					Title: 'main/whom',
					hint: 'person/pattern: Лоханкину Денису Валерьяновичу',
					value: ''
				}
			},
			Value: null
		}
	},

	//=========================================================================
	created() {
		this.Init(this.value)
		EventBus.$on('w5-copy-address-field-value', this.onChangeValueEvent)
	},

	//=========================================================================
	beforeDestroy() {
		EventBus.$off('w5-copy-address-field-value', this.onChangeValueEvent)
	},

	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		fieldVisibility(fieldName) {
			if (fieldName === 'index' || fieldName === 'address')
				return true

			return (this.validator === 'address_post_russian')
		},

		//---------------------------------------------------------------------
		needCopyButton(fieldName) {
			if (this.crud === 'person' && fieldName === 'address' && !this.fieldVisibility('receiver'))
				return true

			if (this.crud === 'payer' && fieldName === 'address' && !this.fieldVisibility('receiver') && this.name.indexOf('post_addr') < 0)
				return true

			return false
		},

		//---------------------------------------------------------------------
		Init(Value) {
			this.fields.index.value = ''
			this.fields.address.value = ''
			this.fields.receiver.value = ''

			this.fields.address.title = this.title

			if (Value !== undefined && Value !== null)
			{
				let _parts = String(Value).split(',')
				if (_parts.length === 1)
				{
					this.fields.index.value = _parts[0]
				}
				else if (_parts.length === 2)
				{
					this.fields.index.value = _parts[0].trim()
					this.fields.address.value = _parts[1].trim()
				}
				else if (_parts.length >= 3)
				{
					let _end = ''
					this.fields.index.value = _parts.shift().trim()
					if (this.fieldVisibility('receiver'))
					{
						let _tmp = ''
						let _words = _parts.pop().trim().split(' ')

						for (let _idx = _words.length - 1; _idx >= 0; _idx--)
						{
							if (/^[а-яёa-z.-]+$/i.test(_words[_idx]))
							{
								_tmp = (_words[_idx] + ' ' + _tmp).trim()
							}
							else
							{
								_end = (_words.slice(0, _idx + 1).join(' ')).trim()
								break
							}
						}

						this.fields.receiver.value = _tmp
					}
					this.fields.address.value = (_parts.join(',').trim() + ' ' + _end).trim()
				}

				this.makeValue()
			}
		},

		//---------------------------------------------------------------------
		onChangeValueEvent(data) {
			if (!data || !data.fields || data.name !== this.name) return

			this.fields.index.value = data.fields.index && data.fields.index.value ? data.fields.index.value : ''
			this.fields.address.value = data.fields.address && data.fields.address.value ? data.fields.address.value : ''

			this.makeValue()
			this.$emit('input', this.Value)
		},

		//---------------------------------------------------------------------
		onFocus(fieldName) {
			this.fields[fieldName].focused = true
			this.fields[fieldName].error = ''
			this.$emit('focus')
		},

		//---------------------------------------------------------------------
		onBlur(fieldName) {
			this.fields[fieldName].focused = false
			this.$emit('blur')
		},

		//---------------------------------------------------------------------
		enterKeyDown(e) {
			this.$emit('enterKeyDown', e)
		},

		//---------------------------------------------------------------------
		onInput(what, event) {
			if (!what) return

			if (event && event.target && this.fields[what])
			{
				let _val = event.target.value
				if (what === 'receiver')
					_val = String(_val).replace(/[^ а-яёa-z.-]/ig, '')

				this.$set(this.fields[what], 'value', _val)

				this.makeValue()
				this.$emit('input', this.Value)
			}
		},

		//---------------------------------------------------------------------
		makeValue() {
			this.Value = this.fields.index.value
			if (this.fields.address.value) this.Value += ', ' + this.fields.address.value
			if (this.fieldVisibility('receiver') && this.fields.receiver.value) this.Value += ', ' + this.fields.receiver.value
		},

		//---------------------------------------------------------------------
		copyAddress() {
			if (this.readonly) return
			this.$emit('copyAddress', this.fields)
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.padded-for-btn {
	padding-right: 40px !important;
}
</style>



// WEBPACK FOOTER //
// address.vue?5e0ec32f